module.exports = __webpack_public_path__ + "img/logo-shiba888.4b67fa3a.png";